import { useState } from "react";
import { Typography, Grid } from "@material-ui/core";
import useStyle, { Accordion, AccordionDetails } from "./styles";
// import { useFormatPhone } from "hooks";
import { convertDateAndTime } from "utils";

type AccordionItemProps = {
  data: any;
  index: number;
  cardOpen?: any;
  events: any;
};

export const AccordionItem = ({
  data,
  cardOpen,
  // isOpen,
  index,
  events,
  ...rest
}: AccordionItemProps) => {
  // const { formatPhone } = useFormatPhone();
  const classes = useStyle();
  const [toggle, setToggle] = useState(true);

  // const getPerfil = (data: any) => {
  //   if (!data) return "";
  //   const json = JSON.parse(data);
  //   if (json && json.perfil && json.perfil === "0") {
  //     return "CORREIOS";
  //   } else {
  //     return "";
  //   }
  // };

  // const statusName = (num: number) => {
  //   if (!num) return "";
  //   const status = events.find((item: any) => item.value === num);
  //   if (status) {
  //     return status.label;
  //   } else {
  //     return "STATUS NÃO ENCONTRADO";
  //   }
  // };

  const checkBox = (box:number) => {

    if(!box)
      return '-';
    
    return box;
    
  }

/*
CDNOTIF    DSNOTIFCODE    DSNOTIFCODEEXT
501    CorreiosLoggedOff    Encerramento de sessão (logoff)
502    CorreiosClockAdjusted    Evento de relógio corrigido para notificacao aos Correios
503    CorreiosBlockedBox    Bloqueio de box danificado
504    CorreiosUnblockedBox    Desbloqueio de box danificado
505    CorreiosNoBoxAvailable    Indisponibilidade total de boxes para distribuição
506    CorreiosNoBoxFromSizeAvailable    Tamanho de box selecionado indisponível
507    CorreiosOperationPickup    Retirada da encomenda
508    CorreiosOperationDelivery    Entrega de encomenda
509    CorreiosOnLine    Equipamento disponivel
*/

  const enumToCorreiosCode = (code:number) => {
    switch(code){
      case 500: return 'LG';
      case 501: return 'OF';
      case 502: return 'AR';
      case 503: return 'CD';
      case 504: return 'DC';
      case 505: return 'CI';
      case 506: return 'IC';
      case 507: return 'RE';
      case 508: return 'EN';
      case 509: return 'ED';      
      default: return '-';
    }
  }

  const gridTitle = {
    fontWeight: 700,
    color: "var(--black)"
  }

  const gridData = {
    fontWeight: 500,
    color: "#616161",
    marginBottom: '10px',
  }

  return (
    <>
      <Accordion
        {...rest}
        square
        expanded={toggle}
        onChange={() => setToggle(!toggle)}
      >
        <AccordionDetails className={classes.divDetails}>
          <Grid container>
            <Grid item xs={6} sm={4} lg={2}>
              <Typography className={classes.modulocker}>
                <div style={gridTitle}>
                  Data/Hora
                </div>
                <div style={gridData}>
                  {convertDateAndTime(data?.DTNOTIF)}
                </div>
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} lg={2}>
              <Typography className={classes.modulocker}>
                <div style={gridTitle}>
                  Complemento
                </div>
                <div style={gridData}>
                  {data?.COMPLEMENTO ? data.COMPLEMENTO : '-'}
                </div>
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} lg={2}>
              <Typography className={classes.modulocker}>
                <div style={gridTitle}>
                  Usuário
                </div>
                <div style={gridData}>
                  {data?.NMUSUARIO ? data.NMUSUARIO : '-'}
                </div>
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} lg={2}>
              <Typography className={classes.modulocker}>
                <div style={gridTitle}>
                  Perfil
                </div>
                <div style={gridData}>
                  {data?.PERFIL}
                </div>
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} lg={2}>
              <Typography className={classes.modulocker}>
                <div style={gridTitle}>
                  Box
                </div>
                <div style={gridData}>
                  {checkBox(data?.NUMERO)}
                </div>
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} lg={2}>
              <Typography className={classes.modulocker}>
                <div style={gridTitle}>
                  Código Correios
                </div>
                <div style={gridData}>
                  {enumToCorreiosCode(+data?.CDNOTIF)}
                </div>
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography className={classes.evento}>
                <div style={{...gridData, marginBottom: '0'}}>                
                  {data?.DSNOTIFCODEEXT?data.DSNOTIFCODEEXT:'-'}
                </div>
              </Typography>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
  );
};
